module.exports = __webpack_public_path__ + "static/media/three_quarters_right_front_picture.82d003bb.jpg";